export default __webpack_public_path__ + "static/media/req_map.8bb9f248.svg";